import React, { useState } from 'react';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { NavBar } from '@spotify-internal/s4x-masthead';
import styled from 'styled-components';
import { cssColorValue, screenSmMax, spacer72 } from '@spotify-internal/encore-web';

const Spacer = styled.div`
  height: 92px; /* navbar height: 76px, + extra spacing of 16px */
  @media (max-width: ${screenSmMax}) {
    height: ${spacer72};
  }
`;

export default function S4AHeader() {
  const [navBarBackground, setNavBarBackground] = useState<string | undefined>();
  const [navBarTextColor, setNavBarTextColor] = useState<string | undefined>(cssColorValue('textBase'));

  useScrollPosition(({ prevPos, currPos }) => {
    if (window.innerWidth > 992) {
      // desktop widths and above
      if (currPos.y < prevPos.y && prevPos.y === 0) {
        // scrolling down: reset nav bar to default colors
        setNavBarBackground(cssColorValue('textBase'));
        setNavBarTextColor(cssColorValue('backgroundBase'));
      } else if (currPos.y > prevPos.y && currPos.y > -1) {
        // scrolling return to 0: reset nav bar colors
        setNavBarBackground(undefined);
        setNavBarTextColor(cssColorValue('textBase'));
      }
    } else {
      // mobile widths
      if (currPos.y > prevPos.y) {
        if (currPos.y <= -56) {
          setNavBarBackground(cssColorValue('textBase'));
          setNavBarTextColor(cssColorValue('backgroundBase'));
        } else {
          setNavBarBackground(undefined);
          setNavBarTextColor(cssColorValue('textBase'));
        }
      }
    }
  }, []);

  return (
    <>
      <NavBar
        colors={{
          background: navBarBackground,
          text: navBarTextColor,
          bleed: true,
        }}
      />
      <Spacer />
    </>
  );
}
